export const ASSESSMENT_TABS = {
  OVERVIEW: 'Overview',
  ISSUES: 'Issues',
  ARTIFACTS: 'Artifacts',
  QUESTIONNAIRES: 'Questionnaires',
  IRQ_QUESTIONNAIRE: 'IRQ Questionnaire',
  CONTROLS: 'Controls',
  CONCLUSION: 'Conclusion',
}
